/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { YDivider } from 'irmlib/styles'
import PropTypes from 'prop-types'
// import cloneDeep from 'clone-deep'
import { DataGrid, GridToolbarContainer, GridToolbarColumnsButton } from '@mui/x-data-grid'

const DivCenter = styled('div')`
  display: flex;
  justify-content: center;
  white-space: nowrap;
  width: 100%;
  margin-bottom: -8px;
`

const BottomPaddedDiv = styled('div')`
  padding-bottom: 20px;
`

const TableContainer = styled(BottomPaddedDiv)`
  max-height: 700px;
`

const DatGridTable = (props) => {
  const { columnsList, showCheckBox, getRowHeight } = props
  // const refFileList = (null)
  const [fileList, setFileList] = useState([])

  useEffect(() => {
    setFileList(props.fileList)
  }, [props.fileList])


  const rows = fileList

  const columns = columnsList
  // eslint-disable-next-line
  function CustomToolbar() {
    return (
      <GridToolbarContainer style={{ flexDirection: 'row-reverse' }}>
        <GridToolbarColumnsButton />
      </GridToolbarContainer>
    )
  }

  return (
    <>
      <YDivider height='30px' />
      <TableContainer>
        <DivCenter style={{ height: 500, width: '100%' }}>
          <DataGrid
            rows={rows}
            apiRef={props.apiRef}
            columns={columns}
            initialState={{
              pagination: false,
            }}
            pageSizeOptions={false}
            checkboxSelection={showCheckBox}
            disableRowSelectionOnClick
            disableColumnMenu
            slots={{
              toolbar: CustomToolbar,
            }}
            getRowHeight ={() => getRowHeight}
          />
        </DivCenter>
      </TableContainer>
    </>
  )
}

DatGridTable.propTypes = {
  apiRef: PropTypes.any,
  showCheckBox: PropTypes.bool
}

export default DatGridTable